module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-mv-bg-sp-56622130411692620234147c88d77c01.png";